import * as http from "./base";

const prefix = "/account-";

export async function fetchAccount() {
  return await http.get(`${prefix}retrieve`);
}

export async function updateAccount(data, id) {
  return await http.patch(`${prefix}update/${id}`, data);
}

export async function refreshToken() {
  return await http.post("/refresh-api-token", {});
}

/**
 * Activate Intercom integration.
 *
 * https://app.intercom.io/a/apps/wuihnasx/settings/web
 */
// prettier-ignore
export function activateIntercom(user, { force = false } = {}) {
  if (process.env.NODE_ENV !== "production" && !force) {
    return
  }

  const intercomSettings = {
    app_id: "wuihnasx",
    name: `${user.firstName} ${user.lastName}`,
    email: user.email,
    created_at: user.created.unix()
  }

  window.Intercom('boot', intercomSettings);
}

export async function fetchActivities() {
  return await http.get("/mail-piece-status-account");
}
